export const anavatanCities = [
  {
    id: 0,
    name: "برگزیده",
    key: "default",
    bg: "/anavatan/anavatan_default.svg",
    style: "!bg-[#85000080] ml-1",
  },
  {
    id: 1,
    name: "آذربایجان شرقی",
    key: "آذربایجان-شرقی",
    bg: "/anavatan/tabriz.svg",
  },
  {
    id: 2,
    name: "آذربایجان غربی",
    key: "آذربایجان-غربی",
    bg: "/anavatan/urmia.svg",
  },
  {
    id: 3,
    name: "اردبیل",
    key: "اردبیل",
    bg: "/anavatan/ardabil.svg",
  },
  {
    id: 5,
    name: "البرز",
    key: "البرز",
    bg: "/anavatan/alborz.svg",
  },
  {
    id: 8,
    name: "تهران",
    key: "تهران",
    bg: "/anavatan/tehran.svg",
  },
  {
    id: 14,
    name: "زنجان",
    key: "زنجان",
    bg: "/anavatan/zanjan.svg",
  },
  {
    id: 18,
    name: "قزوین",
    key: "قزوین",
    bg: "/anavatan/qazvin.svg",
  },
  {
    id: 19,
    name: "سایر",
    key: "سایر",
    bg: "/anavatan/anavatan_default.svg",
    className: "anavatan-default",
  },
];
